import { render, staticRenderFns } from "./SelectRoom.vue?vue&type=template&id=845c79ea&"
import script from "./SelectRoom.vue?vue&type=script&lang=js&"
export * from "./SelectRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports